module.exports = __webpack_public_path__ + "static/media/menu-item-placeholder-mini.dceb415e.png";